import { __assign, __extends } from "tslib";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { sizeClassName, alignmentClassName } from '../../classNameStrategies';
export default function imageComponentWrapper(ExternalComponent) {
    var _a;
    return withDimensions((_a = /** @class */ (function (_super) {
            __extends(ImageComponentWrapper, _super);
            function ImageComponentWrapper(props) {
                var _this = _super.call(this, props) || this;
                _this.handleFilesAdded = function (_a) {
                    var data = _a.data, error = _a.error;
                    var componentData = _this.props.componentData;
                    if (error) {
                        return;
                    }
                    var deviationData = data.length ? data[0] : data;
                    _this.props.store.set('componentData', __assign(__assign({}, componentData), { data: deviationData }), _this.props.block.getKey());
                };
                _this.handleFilesSelected = function (data) {
                    var componentData = _this.props.componentData;
                    _this.props.store.set('componentData', __assign(__assign({}, componentData), { data: data }), _this.props.block.getKey());
                };
                _this.handleMetadataChange = function (newMetadata) {
                    var componentData = _this.props.componentData;
                    var metadata = __assign(__assign({}, componentData.metadata), newMetadata);
                    _this.props.store.set('componentData', __assign(__assign({}, componentData), { metadata: metadata }), _this.props.block.getKey());
                };
                var _a = _this.props, block = _a.block, store = _a.store;
                if (store) {
                    var blockKey = block.getKey();
                    store.setBlockHandler('handleFilesSelected', blockKey, _this.handleFilesSelected.bind(_this));
                    store.setBlockHandler('handleFilesAdded', blockKey, _this.handleFilesAdded.bind(_this));
                    store.setBlockHandler('handleMetadataChange', blockKey, _this.handleMetadataChange.bind(_this));
                }
                return _this;
            }
            ImageComponentWrapper.prototype.render = function () {
                var _a = this.props, _b = _a.componentData, config = _b.config, data = _b.data, width = _a.width, settings = _a.settings;
                return (React.createElement(ExternalComponent, { config: config, data: data, width: width, settings: settings }));
            };
            return ImageComponentWrapper;
        }(React.Component)),
        _a.sizeClassName = function (componentData, theme, styles, isMobile) {
            return sizeClassName(componentData, theme, styles, isMobile);
        },
        _a.alignmentClassName = function (componentData, theme, styles, isMobile) {
            return alignmentClassName(componentData, theme, styles, isMobile);
        },
        _a));
}
//# sourceMappingURL=image-component-wrapper.js.map